var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{style:(_vm.myLayoutStyle),attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","offset-sm1":"","md10":"","offset-md1":"","lg10":"","offset-lg1":"","xl8":"","offset-xl2":""}},[_c('v-card',{attrs:{"flat":"","color":_vm.theme.bg_color}},[_c('v-card-text',[_c('page-title',{attrs:{"title":_vm.$t('favors')}})],1)],1)],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eb9459f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/favors.vue
// module id = 8dXV
// module chunks = 0